"use client";
import CircularProgress from "@mui/material/CircularProgress";

export interface LoadingProps {
  size?: number;
}

export default function Loading({ size = 24 }: LoadingProps) {
  return <CircularProgress size={size} color="inherit" />;
}
